<template>
  <div class="register-wrap" v-if="code">
    <authLeft />
    <div class="register-right">
      <!-- <div class="register-form" v-if="mode=='verifyEmail'">
        <div class="register-form-title">メールアドレスの認証完了</div>
        <img class="register-form-img" src="../../assets/authentication.png" alt />
        <div>
          <div>メールアドレスの認証が完了しました。</div>
          <router-link to="/login">
            <el-button style="width:100%; margin-top:30px;" type="primary">ログイン画面へ</el-button>
          </router-link>
        </div>
      </div> -->
      <div class="register-form" v-if="check_loading">
        <div class="register-form-title">REECH DATABASEへようこそ</div>
        <div class="flex-row">
          登録処理中です...
          <div class="loader--mini blue"></div>
        </div>
      </div>
      <div class="register-form" v-else-if="!error">
        <div class="register-form-title">REECH DATABASE - パスワード設定</div>
        <div style="color: #666; margin-bottom: 30px">REECH DATABASE用のパスワードを設定して登録を完了させてください</div>
        <div class="register-form-subtitle">パスワード</div>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item prop="pass">
            <el-input placeholder="パスワード" v-model="form.pass" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">パスワード(再入力)</div>
          <el-form-item prop="checkPass">
            <el-input placeholder="パスワード(再入力)" v-model="form.checkPass" type="password" autocomplete="off" @change="register()"></el-input>
          </el-form-item>
          <el-button style="width:100%; margin-top:30px;" type="primary" @click="register()" :disabled="loading">
            <div class="flex-row">
              パスワードを設定して登録を完了
              <div class="loader--mini" v-show="loading"></div>
            </div>
          </el-button>
        </el-form>
      </div>
      <div class="register-form" v-else>
        <div class="register-form-title">REECH DATABASE - パスワード設定</div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const thirdpartyAppRegisterAPI = root + "/api/thirdparty/colorme/register";
const checkAPI = root + "/api/thirdparty/colorme/check";
const loginAPI = root + "/api/auth/login";
// const loginNotificationAPI = root + "/api/mail/login_notification";
const protocol = window.location.protocol; // "http:" または "https:"
const hostname = window.location.hostname; // "127.0.0.1"
const port = window.location.port; // "8080"
const fullUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;

function colormeOAuthRedirectBase() {
  const fromEnv = process.env.VUE_APP_PUBLIC_ORIGIN;
  if (fromEnv && String(fromEnv).trim() !== "") {
    return String(fromEnv).replace(/\/$/, "");
  }
  return window.location.origin;
}

/** カラーミー OAuth（shop-pro）の client_id。ビルド時に .env の VUE_APP_COLORME_OAUTH_CLIENT_ID を注入する */
function colormeOAuthClientId() {
  const id = process.env.VUE_APP_COLORME_OAUTH_CLIENT_ID;
  return id && String(id).trim() !== "" ? String(id).trim() : "";
}

function firebaseAuthErrorMessage(err) {
  const code = err && err.code;
  const messages = {
    "auth/email-already-in-use": "このメールアドレスは既に登録されています",
    "auth/invalid-email": "メールアドレスの形式が正しくありません",
    "auth/weak-password": "パスワードが脆弱です。より長く複雑なパスワードを設定してください",
    "auth/operation-not-allowed": "この認証方法は現在ご利用いただけません",
    "auth/network-request-failed": "ネットワークエラーが発生しました。通信環境をご確認ください",
  };
  return messages[code] || "認証処理に失敗しました。しばらくしてからお試しください";
}

export default {
  name: "register",
  components: {
    authLeft,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードは必須です"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワード(再入力)は必須です"));
      } else if (value !== this.form.pass) {
        callback(new Error("パスワードが一致しません"));
      } else {
        callback();
      }
    };
    return {
      code: "",
      error: false,
      loading: false,
      check_loading: true,
      email: "",
      form: {
        pass: "",
        checkPass: "",
      },
      token: "",
      shop: [],
      rules: {
        pass: [
          { required: true, message: "パスワードは必須です", trigger: "blur" },
          { min: 8, message: "パスワードは8文字以上で設定してください", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.code = this.$route.query.code;
    if (!this.code) {
      const client_id = colormeOAuthClientId();
      if (!client_id) {
        console.error("thirdapp_auth: VUE_APP_COLORME_OAUTH_CLIENT_ID is not set");
        return;
      }
      const root_url = colormeOAuthRedirectBase();
      location.href =
        "https://api.shop-pro.jp/oauth/authorize?client_id=" +
        encodeURIComponent(client_id) +
        "&redirect_uri=" +
        encodeURIComponent(root_url + "/auth/thirdapp") +
        "&response_type=code&scope=read_sales";
    } else {
      this.registerCheck();
    }
  },
  methods: {
    resolveColormeShopEmail() {
      const shop = this.shop;
      if (!shop || typeof shop !== "object") {
        return "";
      }
      const raw = shop.user_mail;
      return typeof raw === "string" ? raw.trim() : "";
    },
    async cleanupPartialFirebaseUser(user) {
      if (!user) {
        return;
      }
      try {
        await user.delete();
      } catch (e) {
        console.warn("thirdapp_auth: Firebase user cleanup failed", e);
      }
      try {
        await firebase.auth().signOut();
      } catch (e) {
        /* noop */
      }
    },
    registerCheck() {
      this.check_loading = true;
      var params = new URLSearchParams();
      params.append("code", this.code);
      this.axios
        .post(checkAPI, params)
        .then((response) => {
          if (response.data.status == "exist") {
            this.email = response.data.client.email;
            this.token = response.data.client.token;
            this.form.pass = response.data.pass;
            this.login().catch(() => {
              this.check_loading = false;
            });
          } else if (response.data.status == "OK") {
            this.shop = response.data.shop;
            this.check_loading = false;
          } else {
            this.error = true;
            this.check_loading = false;
          }
        })
        .catch(() => {
          this.error = true;
          this.check_loading = false;
        });
    },
    register() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitRegisterWithFirebase();
        } else {
          this.$message.error("項目を正しく入力してください");
        }
      });
    },
    async submitRegisterWithFirebase() {
      if (this.loading) {
        return;
      }
      const email = this.resolveColormeShopEmail();
      if (!email) {
        this.$message({
          message: "ショップ情報からメールアドレスを取得できませんでした。お手数ですが最初からやり直してください。",
          type: "error",
          offset: 7,
          showClose: true,
        });
        return;
      }

      this.loading = true;
      let credential = null;
      try {
        credential = await firebase.auth().createUserWithEmailAndPassword(email, this.form.pass);
        const uid = credential.user.uid;
        var params = new URLSearchParams();
        params.append("pass", this.form.pass);
        params.append("shop", JSON.stringify(this.shop));
        params.append("uid", uid);
        const response = await this.axios.post(thirdpartyAppRegisterAPI, params);

        if (response.data.status == "NG") {
          await this.cleanupPartialFirebaseUser(credential.user);
          this.$message({
            message: "登録に失敗しました。しばらくしてからお試しください。",
            type: "error",
            offset: 7,
            showClose: true,
          });
        } else if (response.data.status == "email_exist") {
          await this.cleanupPartialFirebaseUser(credential.user);
          this.$message({
            message: "このショップのメールアドレスは既に登録されています",
            type: "error",
            offset: 7,
            showClose: true,
          });
        } else {
          this.email = response.data.registered_data.email;
          this.token = response.data.registered_data.token;
          try {
            await this.login();
          } catch {
            /* login() 内でメッセージ表示済み */
          }
        }
      } catch (err) {
        if (err && err.code && String(err.code).startsWith("auth/")) {
          this.$message({
            message: firebaseAuthErrorMessage(err),
            type: "error",
            offset: 7,
            showClose: true,
          });
        } else {
          if (credential && credential.user) {
            await this.cleanupPartialFirebaseUser(credential.user);
          }
          this.$message({
            message: "登録に失敗しました。しばらくしてからお試しください。",
            type: "error",
            offset: 7,
            showClose: true,
          });
        }
      } finally {
        this.loading = false;
      }
    },
    login() {
      this.$store.dispatch("reset");
      return firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.form.pass)
        .then(() => {
          return this.axios
            .get(loginAPI, {
              params: {
                user_token: this.token,
                accessUrl: fullUrl,
              },
            })
            .then(() => {
              return this.$store.dispatch("getUserData", { token: this.token, user_token: this.token }).then(() => {
                setTimeout(() => {
                  this.$router.push("/dashboard");
                }, 2000);
              });
            });
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("メールアドレスかパスワードが間違っています。");
          return Promise.reject(new Error("login_failed"));
        });
    },
  },
};
</script>
